import React from 'react';
import Hero from '../components/Hero';
import ChannelsStrip from '../components/ChannelsStrip';
import Omnichannel from '../components/Omnichannel';
import AIKnowledge from '../components/AIKnowledge';
import LeadCRM from '../components/LeadCRM';
import Operations from '../components/Operations';
import Testimonials from '../components/Testimonials';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';

export default function Home() {
  return (
    <>
      <Hero />
      <ChannelsStrip />
      <Omnichannel />
      <AIKnowledge />
      <LeadCRM />
      <Operations />
      <Testimonials />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </>
  );
}
